import React, { memo } from "react";
import { Card, Col, Spinner } from "react-bootstrap";
import PropTypes from 'prop-types';

const WidgetCard = ({ children, title, icon, loading }) => {
    return (
        <>
            <Col xs={12} sm={12} md={6} lg={3} style={{ cursor: 'default' }}>
                <Card className="p-3 shadow border-0 h-100">
                    <Card.Title className="ps-1 fs-1 text-700 mb-2"><div><span className="fs-3">{icon}</span> {title}</div></Card.Title>
                    {loading ? <div className="p-3 d-flex justify-content-center"><Spinner animation="border" role="status" /></div> : children}
                </Card>
            </Col>
        </>
    )
}

WidgetCard.propTypes = {
    children: PropTypes.node,
    title: PropTypes.string,
    icon: PropTypes.node,
    loading: PropTypes.bool,
};

export default memo(WidgetCard);